import { render, staticRenderFns } from "./VipDetails.vue?vue&type=template&id=3352ab90&scoped=true"
import script from "./VipDetails.vue?vue&type=script&lang=js"
export * from "./VipDetails.vue?vue&type=script&lang=js"
import style0 from "./VipDetails.vue?vue&type=style&index=0&id=3352ab90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352ab90",
  null
  
)

export default component.exports